// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-detail-sidebar-info {
  display: flex;
  flex-direction: column;
  width: 100%;
}

  .department-detail-sidebar-info__header {
    display: flex;
  }

  .department-detail-sidebar-info__header__text {
      flex: 1;
      font-size: 24px;
      font-weight: 500;
      line-height: 32px;
    }

  .department-detail-sidebar-info__header__loader {
      width: 26px;
      margin-left: 15px;
    }

  .department-detail-sidebar-info__header__loader .r-loading-screen {
        padding: 0;
      }

  .department-detail-sidebar-info__header__loader svg {
        width: 20px;
        padding: 5px 0 0;
        color: #24b248;
      }

  .department-detail-sidebar-info__tab-bar {
    display: flex;
    justify-content: space-between;
  }

  .department-detail-sidebar-info__tab-item {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    margin-right: 2.5px;
  }

  .department-detail-sidebar-info__tab-item-underline {
      background-color: #f7f8f9;
      margin-top: 10px;
      flex-basis: 6px;
      align-self: stretch;
    }

  .department-detail-sidebar-info__tab-item-underline-active {
        background-color: #24b248;
      }

  .department-detail-sidebar-info__form {
    padding: 0 12px;
  }

  .department-detail-sidebar-info__group-title {
      font-weight: 500;
      width: 100%;
      line-height: 24px;
      font-size: 14px;
      margin-top: 25px;
    }

  .department-detail-sidebar-info__group-title:first-child {
        margin-top: 0;
      }

  .department-detail-sidebar-info__label {
    color: var(--color-grayscale-6);
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
  }

  .department-detail-sidebar-info__label__info {
       font-size: 11px;
       font-weight: normal;
     }

  .department-detail-sidebar-info__multi-input-row {
    display: flex;
    align-items: flex-end;
  }

  .department-detail-sidebar-info__input-field-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .department-detail-sidebar-info__loading-zone {
    flex-grow: 1;
  }

  .department-detail-sidebar-info__input-field {
    margin-bottom: 10px;
    width: 100%;
    border-radius: 0;
  }

  .department-detail-sidebar-info__input-field-small {
      max-width: 65px;
      flex-grow: 0;
      margin-left: 6px;
    }

  .department-detail-sidebar-info__input-field-invalid {
      color: red;
    }

  .department-detail-sidebar-info__checkbox-group {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    align-self: stretch;
    justify-content: space-between;
    margin-bottom: 10px;
    width: 65px;
    padding-bottom: 3px;
    margin-left: 6px;
    border: 0;
  }

  .department-detail-sidebar-info__autocomplete-dropdown-container {
    position: absolute;
    top: 27px;
    left: -1px;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-shadow: rgb(0 0 0 / 20%) 0 0 10px 0;
    max-height: 300px;
    z-index: 9;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(204 204 204);
    border-image: initial;
    padding: 0;
    background: rgb(255 255 255);
    border-radius: 2px;
    overflow: auto;
  }

  .department-detail-sidebar-info__autocomplete-dropdown-container .suggestion_item {
      padding: 5px 10px;
    }

  .department-detail-sidebar-info__autocomplete-dropdown-container .suggestion_item--active {
        background-color: #e6f2e9;
      }

  .department-detail-sidebar-info__delete-button {
    margin-top: auto;
    background-color: #2b2b2b;
  }

  .department-detail-sidebar-info__delete-button:hover {
      background-color: #ff5733;
    }

  .department-detail-sidebar-info__delete-button {

    color: white;
}

  .department-detail-sidebar-info-error-message {
    color: red;
  }
`, "",{"version":3,"sources":["webpack://./app/components/DepartmentDetailSidebar/components/DepartmentDetailSidebarInfo/style.css","<no source>"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AAwKb;;EAtKE;IACE,aAAa;EAuBf;;EArBE;MACE,OAAO;MACP,eAAe;MACf,gBAAgB;MAChB,iBAAiB;IACnB;;EAEA;MACE,WAAW;MACX,iBAAiB;IAWnB;;EATE;QACE,UAAU;MACZ;;EAEA;QACE,WAAW;QACX,gBAAgB;QAChB,cAAc;MAChB;;EAIJ;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EAYrB;;EAVE;MACE,yBAAyB;MACzB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;IAKrB;;EAHE;QACE,yBAAyB;MAC3B;;EAIJ;IACE,eAAe;EACjB;;EAGE;MACE,gBAAgB;MAChB,WAAW;MACX,iBAAiB;MACjB,eAAe;MACf,gBAAgB;IAKlB;;EAHE;QACE,aAAa;MACf;;EAIJ;IACE,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAMlB;;EAJE;OACG,eAAe;OACf,mBAAmB;KACrB;;EAGH;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAWlB;;EATE;MACE,eAAe;MACf,YAAY;MACZ,gBAAgB;IAClB;;EAEA;MACE,UAAU;IACZ;;EAGF;IACE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,UAAU;IACV,4BAA4B;IAC5B,kBAAkB;IAClB,cAAc;EAShB;;EAPE;MACE,iBAAiB;IAKnB;;EAHE;QACE,yBAAyB;MAC3B;;EAIJ;IACE,gBAAgB;IAChB,yBAAyB;EAO3B;;EALE;MACE,yBAAyB;IAC3B;;ECnKJ;;IDqKI;CCrKJ;;EDwKE;IACE,UAAU;EACZ","sourcesContent":[".department-detail-sidebar-info {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  &__header {\n    display: flex;\n\n    &__text {\n      flex: 1;\n      font-size: 24px;\n      font-weight: 500;\n      line-height: 32px;\n    }\n\n    &__loader {\n      width: 26px;\n      margin-left: 15px;\n\n      .r-loading-screen {\n        padding: 0;\n      }\n\n      svg {\n        width: 20px;\n        padding: 5px 0 0;\n        color: #24b248;\n      }\n    }\n  }\n\n  &__tab-bar {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &__tab-item {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    align-items: center;\n    margin-right: 2.5px;\n\n    &-underline {\n      background-color: #f7f8f9;\n      margin-top: 10px;\n      flex-basis: 6px;\n      align-self: stretch;\n\n      &-active {\n        background-color: #24b248;\n      }\n    }\n  }\n\n  &__form {\n    padding: 0 12px;\n  }\n\n  &__group {\n    &-title {\n      font-weight: 500;\n      width: 100%;\n      line-height: 24px;\n      font-size: 14px;\n      margin-top: 25px;\n\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n  }\n\n  &__label {\n    color: var(--color-grayscale-6);\n    font-size: 12px;\n    line-height: 24px;\n    font-weight: 500;\n\n    &__info {\n       font-size: 11px;\n       font-weight: normal;\n     }\n  }\n\n  &__multi-input-row {\n    display: flex;\n    align-items: flex-end;\n  }\n\n  &__input-field-container {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n\n  &__loading-zone {\n    flex-grow: 1;\n  }\n\n  &__input-field {\n    margin-bottom: 10px;\n    width: 100%;\n    border-radius: 0;\n\n    &-small {\n      max-width: 65px;\n      flex-grow: 0;\n      margin-left: 6px;\n    }\n\n    &-invalid {\n      color: red;\n    }\n  }\n\n  &__checkbox-group {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    align-self: stretch;\n    justify-content: space-between;\n    margin-bottom: 10px;\n    width: 65px;\n    padding-bottom: 3px;\n    margin-left: 6px;\n    border: 0;\n  }\n\n  &__autocomplete-dropdown-container {\n    position: absolute;\n    top: 27px;\n    left: -1px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    box-shadow: rgb(0 0 0 / 20%) 0 0 10px 0;\n    max-height: 300px;\n    z-index: 9;\n    border-width: 1px;\n    border-style: solid;\n    border-color: rgb(204 204 204);\n    border-image: initial;\n    padding: 0;\n    background: rgb(255 255 255);\n    border-radius: 2px;\n    overflow: auto;\n\n    .suggestion_item {\n      padding: 5px 10px;\n\n      &--active {\n        background-color: #e6f2e9;\n      }\n    }\n  }\n\n  &__delete-button {\n    margin-top: auto;\n    background-color: #2b2b2b;\n\n    &:hover {\n      background-color: #ff5733;\n    }\n\n    color: white;\n  }\n\n  &-error-message {\n    color: red;\n  }\n}\n",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
